import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faBars, 
  faTimes, 
  faChevronDown, 
  faUser, 
  faSignOutAlt,
  faGraduationCap,
  faBook,
  faTools,
  faNetworkWired,
  faStar,
  faEnvelope,
  faInfoCircle,
  faBell
} from '@fortawesome/free-solid-svg-icons';
import { motion, AnimatePresence } from 'framer-motion';
import logo from "../img/logo.svg";
import { useAuth } from '../context/authContext';
import "../assets/modernnavbar.sass";

const ModernNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();

  // Removed scroll detection since navbar is now static
  // useEffect(() => {
  //   const handleScroll = () => {
  //     setScrolled(window.scrollY > 50);
  //   };

  //   window.addEventListener('scroll', handleScroll);
  //   return () => window.removeEventListener('scroll', handleScroll);
  // }, []);

  useEffect(() => {
    setIsOpen(false);
    setActiveDropdown(null);
    setNotificationsOpen(false);
    setProfileOpen(false);
  }, [location]);

  const handleLogout = () => {
    logout();
  };

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const toggleNotifications = () => {
    setNotificationsOpen(!notificationsOpen);
    setProfileOpen(false); // Close other dropdown
  };

  const toggleProfile = () => {
    setProfileOpen(!profileOpen);
    setNotificationsOpen(false); // Close other dropdown
  };

  return (
    <header className="modern-navbar">
      <div className="nav-container">
        <div className="nav-logo">
        <Link to="/" className="is-active">
          <img src={logo} alt="Logo" style={{ height: 40, width: 'auto' }} />
          </Link>
        </div>
        <nav className="nav-menu">
          <Link to="/academy">Academy</Link>
            <Link to="/study">Study</Link>
            <Link to="/journal">Journal</Link>

          <Link to="/tools">Tools</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        <nav className="actions">
          {!user ? (
            <Link to="/login" className="navbar-item">Login</Link>
          ) : (
            <>
              <Link to="/settings" aria-label="Settings">
                <svg width="23" height="25" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.871 19.694c-.6.456-1.257.838-1.96 1.134V22.5a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-1.672a9.022 9.022 0 0 1-1.96-1.134l-1.45.837a2 2 0 0 1-2.733-.732l-1.5-2.598A2 2 0 0 1 1 14.469l1.45-.837a9.12 9.12 0 0 1 0-2.264L1 10.53A2 2 0 0 1 .268 7.8l1.5-2.598A2 2 0 0 1 4.5 4.469l1.45.837a9.022 9.022 0 0 1 1.96-1.134V2.5a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v1.672a9.022 9.022 0 0 1 1.961 1.134l1.45-.837a2 2 0 0 1 2.732.732l1.5 2.598a2 2 0 0 1-.732 2.732l-1.45.837a9.12 9.12 0 0 1 0 2.264l1.45.837a2 2 0 0 1 .732 2.732l-1.5 2.598a2 2 0 0 1-2.732.732l-1.45-.837Zm-5.46-3.018a4.176 4.176 0 1 0 0-8.352 4.176 4.176 0 0 0 0 8.352Z" fill="#FFC107" fillRule="evenodd" />
                </svg>
              </Link>
              <div className="notifications-dropdown">
                <button 
                  aria-label="notifications" 
                  className={`notifications-toggle ${notificationsOpen ? 'active' : ''}`}
                  onMouseEnter={() => {
                    setNotificationsOpen(true);
                    setProfileOpen(false);
                  }}
                >
                  <svg width="21" height="25" xmlns="http://www.w3.org/2000/svg" className="notifications-icon">
                  <path d="M12.314 2.624a7.003 7.003 0 0 1 5.507 6.84v9h2a1 1 0 0 1 0 2h-18a1 1 0 1 1 0-2h2v-9a7.003 7.003 0 0 1 5.508-6.84A1.01 1.01 0 0 1 9.32 2.5v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1c0 .042-.002.084-.007.124Zm3.507 15.84v-9a5 5 0 0 0-10 0v9h10Zm-6.732 3h3.465a2 2 0 1 1-3.465 0Z" fill="#FFC107" fillRule="nonzero" />
                </svg>
              </button>
                <AnimatePresence>
                  {notificationsOpen && (
                    <motion.div
                      className="notifications-menu"
                      initial={{ opacity: 0, y: -10, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -10, scale: 0.95 }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      onMouseLeave={() => setNotificationsOpen(false)}
                    >
                      <div className="notifications-header">
                        <span className="notifications-title">Notifications</span>
                      </div>
                      <div className="notifications-content">
                        <Link to="/messages" className="notification-item empty">
                          <FontAwesomeIcon icon={faBell} className="notification-icon" />
                          <div className="notification-text">
                            <span className="notification-message">You have no messages</span>
                            <span className="notification-time">Click to view messages</span>
                          </div>
                        </Link>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
              <div className="profile-dropdown">
                <Link to="/profile">
                  <button 
                    className={`profile-toggle ${profileOpen ? 'active' : ''}`}
                    onMouseEnter={() => {
                      setProfileOpen(true);
                      setNotificationsOpen(false);
                    }}
                  >
                    <FontAwesomeIcon icon={faUser} />
                  </button>
                </Link>
                <AnimatePresence>
                  {profileOpen && (
                    <motion.div
                      className="profile-menu"
                      initial={{ opacity: 0, y: -10, scale: 0.95 }}
                      animate={{ opacity: 1, y: 0, scale: 1 }}
                      exit={{ opacity: 0, y: -10, scale: 0.95 }}
                      transition={{ duration: 0.2, ease: "easeOut" }}
                      onMouseLeave={() => setProfileOpen(false)}
                    >
                      <div className="profile-header">
                        <span className="profile-title">Account</span>
                      </div>
                      <div className="profile-content">
                        <Link to="/account" className="profile-item">
                          <FontAwesomeIcon icon={faTools} className="profile-icon" />
                          <span>Account Settings</span>
                        </Link>
                        <Link to="/profile-edit" className="profile-item">
                          <FontAwesomeIcon icon={faUser} className="profile-icon" />
                          <span>Profile Settings</span>
                        </Link>
                        <button className="profile-item" onClick={handleLogout}>
                          <FontAwesomeIcon icon={faSignOutAlt} className="profile-icon" />
                          <span>Logout</span>
                        </button>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default ModernNavbar; 
